import React from 'react';
import { useParams } from "react-router";
import { RefActivity } from "../../../api/hooks";
import ActivityView from "../../../common/activity/ActivityView";

const QuotationActivity = () => {
    const { quotationId } = useParams<any>();
    return (
        <div>
            {quotationId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.Equipment}
                    activityRefId={quotationId ?? ""}
                />
            )}
        </div>
    );
};

export default QuotationActivity;